import React from 'react';
import RadioButton, { RadioVariant } from './RadioButton';
import FlexboxContainerComponent from './FlexboxContainer';
import { Space } from 'styles/themeSpaces';

type Direction = 'vertical' | 'horizontal';

interface Props {
  className?: string;
  options: Record<string, string>;
  selectedOption: string;
  isDisabled?: boolean;
  color?: string;
  variant?: RadioVariant;
  direction?: Direction;
  gap?: string;
  compact?: boolean;
  setSelectedOption: (value: string) => void;
}

const RadioList = ({
  className = '',
  options,
  selectedOption,
  isDisabled = false,
  color,
  variant = 'default',
  direction = 'vertical',
  gap,
  compact = false,
  setSelectedOption,
}: Props) => {
  // Tiles need spacing between them; the legacy variant keeps its own padding.
  const resolvedGap = gap ?? (variant === 'tile' ? Space.sp2x : undefined);

  return (
    <FlexboxContainerComponent
      className={className}
      flexDirection={direction === 'horizontal' ? 'row' : 'column'}
      gap={resolvedGap}
    >
      {Object.entries(options).map(([value, label], index) => (
        <RadioButton
          key={value}
          id={`${value}-${index}`}
          name={value}
          label={label}
          value={value}
          checked={selectedOption === value}
          onChangeValue={setSelectedOption}
          disabled={isDisabled}
          color={color}
          variant={variant}
          compact={compact}
        />
      ))}
    </FlexboxContainerComponent>
  );
};

export default RadioList;